import React, { forwardRef } from 'react'

import { HiOutlineXMark } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

import TextInput, {
  TextInputProps,
} from '@/components/common/TextInput/TextInput'

interface TextInputWithClear extends TextInputProps {
  onDelete: () => void
}

const TextInputWithClear = forwardRef<HTMLInputElement, TextInputWithClear>(
  ({ onDelete, className, value, ...props }, ref) => {
    return (
      <div className="relative flex items-center justify-center gap-x-2">
        <TextInput
          ref={ref}
          value={value}
          className={twMerge(className, 'pr-8')}
          {...props}
        />
        <button
          className="absolute top-[10px] right-[8px] transition-opacity duration-100 hover:opacity-70"
          onClick={onDelete}
        >
          <HiOutlineXMark className="w-4 h-4 text-primary-500 dark:text-primary-400" />
        </button>
      </div>
    )
  },
)

TextInputWithClear.displayName = 'TextInputWithClear'

export default TextInputWithClear
